import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Схеетс',
    DASHBOARDS: 'Контролне табле',
    DATABASE_TABLE: 'Табела у бази података',
    VARIABLES: 'Променљиве',
    FILES: 'Фајлови',
    APPS: 'Апликације',
    LABEL: 'Ознака',
    EDIT_TYPE: 'Врста уређивања',
    EDITING_ROW: 'Уређивање реда {label}',
    CREATE_NEW_ROW: 'Креирај нови ред',
    ADD: 'Додај',
    MULTIPLY: 'Множи',
    SET: 'Постави',
    PERCENT_CHANGE: 'Промена процента',
    NAME: 'Име',
    NAME_AND_STYLE: 'Назив и стил',
    PATH: 'Путања',
    SHARE_WITH: 'Дели са',
    SUBMIT: 'Пошаљи',
    EDIT: 'Уреди',
    ANY: 'Било који',
    VIEW: 'Поглед',
    EDITING: 'Уређивање',
    DUPLICATE: 'Дуплирај',
    DUPLICATE_SHEET_LOADING: 'Дуплирање табеле...',
    DUPLICATE_SHEET_SUCCESS: 'Табела је успешно дуплирана',
    DUPLICATE_SHEET_ERROR: 'Грешка при дуплирању табеле',
    DUPLICATE_FOLDER_LOADING: 'Дуплирање фасцикле...',
    DUPLICATE_FOLDER_SUCCESS: 'Фасцикла је успешно дуплирана',
    DUPLICATE_FOLDER_ERROR: 'Грешка при дуплирању фасцикле',
    DELETE_TILE: 'Избриши плочу',
    MATCH_CASE: 'Разликуј велика/мала слова',
    SEARCH: 'Претражи',
    SEARCH_VALUES: 'Претражи вредности',
    IMPORT: 'Увоз',
    MODEL_HEALTH: 'Здравље модела',
    CHECKLIST: 'Контролна листа',
    DYNAMIC_ANALYSIS: 'Динамичка анализа',
    STATIC_ANALYSIS: 'Статичка анализа',
    CALCULATION_LOGS: 'Записи израчунавања',
    ERROR_MESSAGE: 'Порука грешке',
    CALCULATION_TIME_MS: 'Време израчунавања (ms)',
    ERRORS: 'Грешке',
    WARNINGS: 'Упозорења',
    AMPLIFICATION_FACTOR: 'Фактор појачања',
    CELL_COUNT_ESTIMATE: 'Број ћелија (процена)',
    NO_CALCULATION_ERRORS: 'Нема грешака у израчунавању',
    CALCULATION_ERRORS: 'Пронађене грешке у израчунавању',
    NO_MODELLING_ERRORS: 'Нема грешака у моделовању',
    MODELLING_ERRORS: 'Пронађене грешке у моделовању',
    MODEL_FULLY_LOADED: 'Модел је потпуно учитан',
    MODEL_NOT_LOADED: 'Модел није учитан',
    SHARING: 'Дељење',
    ASSIGNMENT: 'Задатак',
    ASSIGNMENTS: 'Задаци',
    LOAD_MORE: 'Учитај још',
    SHARES: 'Акције',
    SHARE: 'Подели',
    OPEN: 'Отвори',
    NONE: 'Ништа',
    TABLE: 'Табела',
    VALUE: 'Вредност',
    DATE: 'Датум',
    NONE_SELECTED: 'Ништа изабрано',
    VALUE_FOR_MONTH: 'Вредност за месец',
    DESCRIPTION: 'Опис',
    NOTES: 'Белешке',
    CUSTOM_FIELD: 'Прилагођено поље',
    TABLE_DESCRIPTION: 'Опис табеле',
    EDIT_COLUMN: 'Уреди колону',
    COLUMN_TYPE: 'Врста колоне',
    MONTH: 'Месец',
    VARIABLE_AND_DIMENSIONS: 'Променљива и димензије',
    SHOW_UNMAPPED: 'Одабери само неповезане ставке',
    MANUAL_MAPPING: 'Ручно мапирање',
    CLEAR: 'Обриши',
    AUTODETECT: 'Аутодетекција',
    FILTER: 'Филтер',
    SELECT_ALL_BRACKETS: '(Одабери све)',
    BLANK_CELLS_BRACKETS: '(Празне ћелије)',
    SELECT_DIMENSIONS: 'Одабери димензије',
    CONFIRM: 'Потврди',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Да ли сте сигурни да желите да уклоните сва мапирања?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'Ова акција ће уклонити све ручно додате ознаке мапирања.',
    ERROR_IMPORTING_FILE: 'Грешка при увозу фајла',
    CHOOSE_JOB_TO_REPLACE: 'Изаберите послу за замену',
    PREVIOUS_IMPORTS: 'Претходни увози',
    WELCOME_TO_IMPORT: 'Добродошли на увоз.',
    IMPORT_SPREADSHEETS: 'Увезите своје табеле из Екцела директно у Фарсеер и управљајте њима.',
    DRAG_FILE_HERE: 'Повуците ваш фајл овде',
    OR: 'ИЛИ',
    BROWSE: 'Прегледај',
    IMPORT_MISSING_MEMBERS: 'Увези недостајуће чланове',
    IMPORT_VALUES: 'Увези вредности',
    NO_COLUMN_SET_AS_TABLE: 'Нема колоне постављене као димензија',
    NO_COLUMN_SET_AS_VALUE: 'Нема колоне постављене као вредност',
    MISSING_MEMBERS: 'Недостају чланови димензије',
    SELECT_ALL: 'Одабери све',
    DESCRIPTION_COLUMN: 'Колона са описом',
    CONNECTED_DIMENSIONS_COLUMN: 'Повезани димензије стубло',
    CANCEL: 'Откажи',
    CONTINUE: 'Настави',
    CREATE_DIMENSIONS: 'Креирај димензије',
    SELECT_CONNECTION: 'Одабери везу',
    CLOSE: 'Затвори',
    SAVE: 'Сачувај',
    DELETE: 'Обриши',
    REMOVE: 'Уклони',
    DELETING_ASSIGNMENT: 'Брисање задатка {multiple} ...',
    DELETED_ASSIGNMENT: 'Задатак {multiple} је обрисан!',
    FAILED_DELETE_ASSIGNMENT: 'Није успело брисање задатка {multiple}',
    DELETE_ASSIGNMENT: 'Обриши задатак {multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Да ли желите да обришете изабрани задатак {multiple}?',
    COLUMNS: 'Колоне',
    FORMATTING: 'Форматирање',
    PRESERVE_FORMATTING: 'Задржи форматирање',
    CUSTOM_FORMATTING: 'Прилагођено форматирање',
    GROUP_OUTLIERS: 'Групиши одступања',
    VERSIONS: 'Верзије',
    NONE_VERSION: 'Ниједна',
    APPLY_TO_ALL_YEARS: 'Примени на све године',
    SHEET_OPTIONS: 'Опције листа',
    DASHBOARD_OPTIONS: 'Опције контролне табле',
    LOCK_GRID: 'Закључај мрежу',
    RESPONSIVE_LAYOUT: 'Прилагодљиви распоред',
    AUTO_REFRESH_DASHBOARD: 'Аутоматско освежавање контролне табле',
    REFRESH_DASHBOARD: 'Освежи контролну таблу',
    ONLY_WITH_DATA: 'Само са подацима',
    OWD_INCLUDE_MEASURES: 'Укључи мере',
    STACKED: 'Слагано',
    TIMELINE: 'Временска линија',
    RESET_COLUMN_ORDER: 'Ресетуј редослед колона',
    STANDARD_COLUMNS_NAME: 'Име',
    STANDARD_COLUMNS_DESCRIPTION: 'Опис',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Име + опис',
    DOWNLOADING_FILE: 'Преузимање фајла',
    FILE_DOWNLOADED: 'Фајл је преузет',
    FAIL_FILE_DOWNLOAD: 'Неуспело извоз из одабране конфигурације',
    ADD_TO_DASHBOARD: 'Додај на таблу',
    COPY_TO_DASHBOARD: 'Копирај на контролну таблу',
    SUBMIT_ENTRIES_CONFIRMATION: 'Да ли сте сигурни да желите да пошаљете уносе?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Након слања нећете моћи вршити додатне измене и веза ће бити закључана.',
    LINK_NOT_FOUND: 'Веза није пронађена',
    LINK_EXPIRED: 'Овај веза је истекла',
    DEPLOYMENT: 'Имплементација',
    UNKNOWN: 'Непознато',
    FILE_SIZE_10GB: 'Величина фајла > 10GB',
    FILE_SIZE_64MB: 'Величина фајла > 64MB',
    FILE_SIZE_1MB: 'Величина фајла > 1MB',
    FILE_SIZE_TOO_LARGE: 'Величина фајла је превелика',
    UPLOADED: 'Пренесено',
    ERROR_UPLOADING_FILE: 'Грешка при отпремању фајла',
    FOLDER_NAME: 'Име фасцикле',
    NEW_DIMENSION_TABLE: 'Нова димензионална табела',
    NEW_VARIABLE: 'Нова променљива',
    NEW_DASHBOARD: 'Нова табла',
    NEW_SHEET: 'Нова табела',
    UPLOAD_FILE: 'Поставите фајл',
    NEW_FOLDER: 'Нова фасцикла',
    NEW_REMOTE_JOB: 'Нова апликација',
    DOWNLOAD: 'Преузимање',
    DELETE_MENU_ITEM_CONFIRM: 'Да ли сте сигурни да желите да избришете {menuItem}?',
    USER_REMOVED: 'Корисник је уклоњен!',
    FAILED_USER_REMOVE: 'Није успело брисање корисника',
    USER_DELETING: 'Брисање корисника {fullName}',
    USER_DELETING_CONFIRM: 'Да ли сте сигурни да желите да избришете корисника {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Потврди брисање операције',
    DELETE_YEAR_CONFIRMATION: 'Да ли сте сигурни да желите да избришете годину {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Да ли сте сигурни да желите да избришете варијацију {name}?',
    YEARS: 'Године',
    YEAR: 'Година',
    ADD_YEAR: 'Додај {year}',
    OPTIONS: 'Опције',
    NO_VERSION_SELECTED: 'Није одабрана верзија',
    INTERVAL_START_GREATER: 'Почетак интервала већи од неких крајева интервала',
    INTERVAL_END_GREATER: 'Крај интервала мањи од неких почетака интервала',
    INTERVAL_START_GREATED_END: 'Почетак интервала већи од краја',
    NO_NAME_INPUT: 'Задатак мора имати име',
    EDIT_ASSIGNMENTS: 'Уреди задатке',
    ASSIGNMENT_NAME: 'Име задатка',
    VERSION: 'Верзија',
    ADD_VERSION: 'Додај верзију',
    ADD_NEW_VERSION: 'Додај нову верзију',
    NEW_VERSION_NAME: 'Име нове верзије',
    ERROR_ADDING_VERSION: 'Грешка при додавању верзије.',
    NAME_AND_COLOR: 'Име и боја',
    ADDED_BY: 'Додато од стране',
    CREATE_SERVICE_USER: 'Направи корисника услуге',
    CREATE_USER: 'Направи корисника',
    USER_TYPE: 'Тип корисника',
    STANDARD: 'STANDARD',
    SERVICE: 'СЕРВИС',
    CREATED_SERVICE_USER: 'Корисник услуге направљен',
    FAILED_CREATE_SERVICE_USER: 'Неуспело прављење корисника услуге и API кључа',
    SERVICE_USER_NAME_REQUIRED: 'Име корисника услуге је обавезно',
    CREATED_USER: 'Корисник је направљен',
    FAILED_CREATE_USER: 'Неуспело прављење корисника',
    LAST_NAME_REQUIRED: 'Презиме је обавезно',
    FIRST_NAME_REQUIRED: 'Име је обавезно',
    EMAIL_REQUIRED: 'Е-пошта је обавезна',
    PASSWORD_REQUIRED: 'Лозинка је обавезна',
    PASSWORD_INCORRECT: 'Погрешна лозинка',
    FIRST_NAME: 'Име',
    LAST_NAME: 'Презиме',
    EMAIL: 'Е-пошта',
    PASSWORD: 'Лозинка',
    CONFIRM_PASSWORD: 'Потврдите лозинку',
    API_KEY: 'API кључ',
    CREATED_SERVICE_USER_API_KEY: 'API кључ за корисника услуге {serviceUserName} је направљен',
    API_KEY_COPIED_TO_CLIPBOARD: 'API кључ је копиран у клипборд',
    CONNECT: 'Повежи се',
    DISCONNECT: 'Одсвоји се',
    MIXED_VERSIONS: 'Мешовите верзије',
    MIXED: 'Мешовито',
    USE_RESTRICTIONS: 'Ограничи унос на верзије и интервале',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Дозволи унос у колоне својстава',
    PROPERTY_COLUMNS: 'Колоне својстава',
    USE_TIME_LIMIT: 'Користи временско ограничење',
    SELECT_VERSION: 'Изаберите верзију',
    EXPIRES_AFTER: 'Истиче након',
    CHANGE: 'Промени',
    SMART_FILTER_CHANGE: 'Промена',
    CHANGES_SUBMITTED: 'Промене су поднете. Чека се преглед.',
    SUBMITTED: 'Поднесено',
    ASSIGNMENTS_AVAILABLE: 'задаци су доступни',
    SUBMITTING_ASSIGNMENT: 'Подношење задатка',
    SUBMITED_ASSIGNMENT: 'Задатак је поднет',
    FAIL_SUBMIT_ASSIGNMENT: 'Неуспело подношење задатка',
    ASSIGNMENT_LABEL_CREATED: 'Етикета је креирана и додата задатку',
    SUBMIT_CHANGES: 'Поднети измене?',
    SUBMIT_CHANGES_CONFIRMATION: 'Да ли сте сигурни да желите да поднесете измене? Нећете моћи да вршите даље измене, процес ће бити означен као Спремно за преглед и власник ове табеле ће бити обавештен.',
    CANT_UNDONE_ACTION: 'Ова радња се не може поништити',
    APP_LANGUAGE: 'Језик апликације',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Циљна верзија не може бити иста као изворна верзија',
    TARGET_VERSION: 'Циљна верзија',
    SELECT_TARGET_VERSION: 'Молимо изаберите циљну верзију',
    SOURCE_VERSION: 'Изворна верзија',
    SELECT_SOURCE_VERSION: 'Молимо изаберите изворну верзију',
    ROW_TAGS: 'Ознаке реда',
    DELETE_THIS_ROW: 'Избриши овај ред',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Изаберите надређени ознаку за генерисање више редова',
    GLOBAL_SEARCH_PLACEHOLDER: 'Претражите табеле, контролне табеле, базе података и променљиве',
    NO_RESULTS_FOUND: 'Нема резултата',
    NEW_TILE: 'Нова плочица',
    SLICER_STATE_SAVED: 'Слицер стање сачувано за све!',
    INVALID_LINK: 'Неважећа веза',
    LINK_NOT_EXIST: 'Веза не постоји',
    ACCESS_NOT_GRANTED: 'Приступ домаћину није дозвољен',
    CONTACT_ADMIN: 'Молимо контактирајте свог администратора за више информација',
    LOGOUT: 'Одјава',
    REGENERATING_LINKS: 'Регенерација веза...',
    REGENERATED: 'Регенерисано!',
    FAILED_REGENERATING_LINKS: 'Неуспела регенерација веза за изабране јавне задатке',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Регенерисати везе за изабране задатке?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Да ли сте сигурни да желите да регенеришете везе за изабране задатке? Старе везе ће бити неисправне. Ова радња се не може поништити.',
    REGENERATE: 'Регенериши',
    REGENERATE_LINK: 'Регенериши везу',
    SHEET_NOT_FOUND: 'Табела није пронађена',
    CLUSTER_NOT_FOUND: 'Кластер није пронађен',
    PARENT_CLUSTER_NOT_FOUND: 'Надређени кластер није пронађен',
    TAG_NOT_FOUND: 'Ознака није пронађена',
    SHEET_ID_NOT_FOUND: 'Идентификациони број табеле није пронађен',
    FAIL_CREATE_ROW: 'Неуспело креирање реда',
    FAIL_CREATE_CLUSTER: 'Неуспело креирање кластера',
    ROW_CREATED: 'Ред је креиран',
    COLUMN_CREATED: 'Колона креирана',
    DIMENSION_CREATED: 'Димензија је креирана',
    NOT_IMPLEMENTED_YET: 'Још увек није имплементирано',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Поље променљивих треба да садржи само променљиве',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Непозната зона у једној вредности',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Поље филтера треба да садржи ознаке димензије',
    UNKNOWN_ZONE_DATA_EDITOR: 'Непозната зона у едитору података',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Поље променљивих треба да садржи ознаке рачуна',
    CUSTOM_COLUMN_NOT_FOUND: 'Прилагођена колона није пронађена',
    CANT_ADD_TO_COLUMN: 'Не могу додати {tagType} у тип колоне {columnType}',
    TAG_ALREADY_ADDED: 'Ова ознака је већ додана',
    MODEL_IMPORT_IN_PROGRESS: 'Увоз модела је у току...',
    MODEL_IMPORT_SUCCESS: 'Модел је успешно увезен.',
    CODE_EDITOR_ALLOW_CHANGES: 'Дозволите уређивачу кода да направи измене у моделу:',
    ALLOW_ALL: 'Дозволи све',
    DELETE_MEMBER_ROWS: 'Обриши редове',
    DELETE_TABLES: 'Обриши табеле',
    DELETE_VARIABLES: 'Обриши променљиве',
    DELETE_COLUMNS: 'Обриши колоне',
    DELETE_CELLS: 'Обриши ћелије',
    DELETE_EVERYTHING: 'Обриши све при примени измена',
    DRY_RUN: 'Суво покретање',
    MODEL_CODE_EDITOR: 'Уређивач кода модела',
    MODEL_IMPORT_EXPORT: 'Увоз/Извоз модела',
    MODEL_IMPORT: 'Увоз модела',
    MODEL_EXPORT: 'Извоз модела',
    MODEL_USE_IN_EXPORT: 'Користи у извозу',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Табеле димензија',
        DMEM: 'Чланови димензија',
        VAR: 'Променљиве',
        CELL: 'Ћелије',
    },
    LOADING: 'Учитавање...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Анализирање вашег питања',
    CHAT_STATS_ACTIONS: '{count} {{акција|акције}}',
    CHAT_STATS_CONTEXT: '{tokens} контекст',
    CHAT_STATS_DURATION_TOOLTIP: 'Колико је времена било потребно да се генерише овај одговор',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Колико је радњи агент извршио (учитавање вештина, покретање кода)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Тренутна величина контекста разговора. Старије поруке се сумирају када постане превелик.',
    CHAT_DEFAULT_TITLE: 'Разговор',
    CHAT_ENTER_FULLSCREEN: 'Целоекрански приказ',
    CHAT_EXIT_FULLSCREEN: 'Изађи из целоекранског приказа',
    CHAT_RENAME: 'Преименуј разговор',
    CHAT_DELETE: 'Обриши разговор',
    CHAT_CREATE_NEW: 'Креирај нови разговор',
    CHAT_MESSAGE_PLACEHOLDER: 'Порука за FarseerAI...',
    CHAT_SEND: 'Пошаљи',
    CHAT_RENAME_TITLE: 'Преименуј разговор',
    CHAT_HELP_QUESTION: 'Како вам могу помоћи данас',
    CHAT_SUGGESTED: 'Предложено',
    CHAT_GENERATING_SUGGESTIONS: 'Прилагођавам предлоге вашем моделу…',
    CHAT_SUGGESTED_SUMMARY: 'Дај ми кратак сажетак модела',
    CHAT_SUGGESTED_VARIANCE: 'Које је највеће одступање између оствареног и плана ове године, и зашто?',
    CHAT_SUGGESTED_DRIVERS: 'Разложи шта покреће моје резултате у овом кварталу',
    CHAT_SUGGESTED_DASHBOARD: 'Направи контролну таблу за извршни преглед за овај модел',
    CHAT_SUGGESTED_PNL_DASHBOARD: 'Направи P&L контролну таблу која пореди остварено са планом',
    CHAT_SUGGESTED_APPS: 'Шта могу да покренем одавде? Прикажи моје доступне апликације',
    CHAT_SUGGESTED_RANKING: 'Прикажи ми најуспешније и најслабије по учинку ове године',
    CHAT_CREATED: 'Разговор створен!',
    CHAT_CREATED_NEW: 'Нови разговор креиран!',
    CHAT_RENAMED: 'Разговор преименован!',
    CHAT_DELETED: 'Разговор обрисан!',
    CHAT_FAILED_CREATE: 'Није успело креирање новог разговора.',
    CHAT_FAILED_LOAD: 'Није успело учитавање разговора.',
    CHAT_FAILED_RENAME: 'Није успело преименовање разговора.',
    CHAT_FAILED_DELETE: 'Није успело брисање разговора.',
    CHAT_FAILED_CANCEL: 'Отказивање захтева није успело.',
    CHAT_FEEDBACK_FAILED: 'Чување повратних информација није успело.',
    CHAT_FEEDBACK_THUMBS_UP: 'Добар одговор',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Лош одговор',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Реците нам шта је пошло по злу',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Шта је било корисно или шта је пошло по злу? (опционо)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Сачувај',
    CHAT_FEEDBACK_CLEAR: 'Обриши повратне информације',
    CHAT_AGENT_TYPE_ANALYST: 'Аналитичар',
    ADVANCED_SETTINGS: 'Напредне поставке',
    INVALID_JSON_ERROR: 'Неважећи JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Режим одржавања је тренутно укључен',
    MAINTENANCE_MODE_ENABLED: 'Режим одржавања је тренутно омогућен',
    CONTACT_ADMIN_FOR_INFO: 'Молимо сачекајте или контактирајте свог администратора за више информација.',
    RETRY: 'Покушај поново',
    OTHER_WORKSPACES_AVAILABLE: 'Пређите на радни простор ком можете да приступите:',
    COPY_LINK: 'Копирај везу',
    COPY_DATA_FROM: 'Копирај податке из',
    ROWS_CUT: 'Редови исечени',
    ROWS_COPIED: 'Редови копирани',
    ROWS_MOVED: 'Редови премештени',
    ROWS_PASTED: 'Редови залепљени',
    CELLS_CUT: 'Ћелије исечене',
    CELLS_COPIED: 'Ћелије копиране',
    CELLS_COPIED_FROM: 'Ћелије копиране из "{label}"',
    FAILED_CELLS_COPIED: 'Неуспело копирање ћелија {message}',
    CANNOT_CELLS_PASTED: 'Не може да се залепи ћелије овде',
    NAMED_COPY: '{name} (копија)',
    TAG: 'Ознака',
    ACTION: 'Акција',
    MANAGE_CONNECTIONS_FOR: 'Управљајте везама за',
    RENAME: 'Преименовати',
    RENAME_FILE_EXTENSION_REQUIRED: 'Називи фајлова морају имати екстензију, као што су .csv или .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Променити екстензију фајла?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'Ово мења екстензију из „.{oldExt}“ у „.{newExt}“, што може променити начин на који се фајл отвара. Наставити?',
    REMOVE_COLUMN: 'Уклонити колону',
    REMOVE_CONNECTION: 'Уклонити везу',
    TABLE_CONNECTION: 'Веза табеле',
    TEXT: 'Текст',
    TEXT_COLUMN: 'Текст колона',
    NUMBER: 'Број',
    NUMBER_COLUMN: 'Број колона',
    NEW_NUMBER_COLUMN: 'Нови број колона',
    FILE: 'Фајл',
    FILE_COLUMN: 'Фајл колона',
    DATE_COLUMN: 'Датум колона',
    EDIT_TAG_TYPE: 'Уреди {tagTypeName}',
    DELETE_TAG_TYPE: 'Обриши {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Обриши податке {tagTypeName}',
    CONNECTIONS: 'Везе',
    EDIT_CONNECTIONS: 'Уреди везе',
    CLEAR_FIELD: 'Очисти поље',
    ERROR_CLEAR_FIELD: 'Грешка при чишћењу поља',
    REPLACE_FILE: 'Замени фајл',
    DOWNLOAD_FILE: 'Преузми фајл',
    DOWNLOAD_ORIGINAL_FILE: 'Преузми оригинални фајл',
    FILE_DOES_NOT_EXIST: 'Фајл не постоји',
    DELETE_FILE: 'Обриши фајл',
    ERROR_DELETE_FILE: 'Грешка при брисању фајла',
    LOCKS: 'Закључавање',
    YEARS_VERSIONS_MONTHS: 'Године / Верзије / Месеци',
    CUSTOM_LOCK_RULES: 'Прилагођена правила закључавања',
    STANDARD_LOCK_RULES: 'Стандардна правила закључавања',
    LOCK_RULES_WILL_BE_CONVERTED_TO_STANDARD: '{{1 правило закључавања|?? правила закључавања}} ће бити примењено на табелу Године / Верзије / Месеци',
    LOCK_WILL_BE_CONVERTED_TO_STANDARD: 'Ово правило закључавања ће бити примењено на табелу Године / Верзије / Месеци изнад',
    NO_CUSTOM_LOCKS_DEFINED: 'Нису дефинисана прилагођена правила закључавања',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Ово закључавање упућује на обрисане ентитете',
    TABLE_SETTINGS: 'Поставке табеле',
    NEW_MEMBER: 'Нови члан',
    SORT_TABLE: 'Сортирај табелу',
    LOCK_TABLE: 'Закључај табелу',
    UNLOCK_TABLE: 'Откључај табелу',
    TABLE_LOCKED_TOOLTIP: 'Ова табела је закључана',
    UNLOCK_SYSTEM_TABLE_TITLE: 'Откључај системску табелу',
    UNLOCK_SYSTEM_TABLE_WARNING: 'Ово је системска табела. Њено откључавање може утицати на интегритет модела. Да ли сте сигурни да желите да је откључате?',
    ERROR_LOCKING_TABLE: 'Грешка при закључавању табеле.',
    ERROR_UNLOCKING_TABLE: 'Грешка при откључавању табеле.',
    NAME_ASCENDING: 'Име узлазно',
    NAME_DESCENDING: 'Име силазно',
    ADD_SORT_RULE: 'Додај правило сортирања',
    REMOVE_ALL_SORT_RULES: 'Уклони сва правила сортирања',
    '1_SORT': '1 сортирање',
    N_SORTS: '{count} сортирања',
    DESCRIPTION_ASCENDING: 'Опис узлазно',
    DESCRIPTION_DESCENDING: 'Опис силазно',
    SORTING_DIMENSIONS: 'Сортирање димензија...',
    DIMENSIONS_SORTED: 'Димензије сортиране!',
    ERROR_SORTING_DIMENSIONS: 'Грешка при сортирању димензија.',
    EDITING_TIMELINE_SLICER: 'Уређивање временског сечива {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Направи нови временски сечиво',
    INTERVAL_START: 'Почетак интервала',
    INTERVAL_END: 'Крај интервала',
    FORMAT: 'Формат',
    OPERATION: 'Операција',
    MY_PROFILE_INFORMATION: 'Информације о мом профилу',
    PROFILE_SETTINGS: 'Подешавања профила',
    ADD_PHOTO: 'Додај фотографију',
    CHANGE_PHOTO: 'Промени фотографију',
    UPDATE_PHOTO: 'Ажурирај фотографију',
    REMOVE_PHOTO: 'Уклони фотографију',
    DECIMAL_SEPARATOR: 'Децимални раздвајач',
    DATE_FORMAT: 'Формат датума',
    DATE_SEPARATOR: 'Раздвајач датума',
    ACCESSIBLE_CHART_PATTERNS: 'Обрасци приступачности за графиконе',
    SET_AS_DEFAULT_PALETTE: 'Постави као подразумевану палету',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Сачувај тренутне боје као палету',
    DELETE_PALETTE: 'Обриши палету',
    FILL_STYLE: 'Стил испуне',
    SOLID: 'Пуно',
    HATCHED: 'Шрафирано',
    VARIABLE: 'Променљива',
    DIMENSION: 'Димензија',
    CREATE_OR_GENERATE_NEW_ROWS: 'Направи или генериши нове редове',
    CREATE_ROW_AS: 'Направи {row} као',
    GENERATE_ROWS_FROM: 'Генериши ред(ове) из',
    CREATE_NEW_VARIABLE: 'Направи нову променљиву',
    ENTER_FORMULA_FOR: 'Унесите формулу за {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Изаберите варијаблу за преглед или измену формуле',
    DATABASE_AND_PROPERTIES: 'База података и својства',
    FOLDER_EMPTY: 'Фасцикла је празна',
    DASHBOARD_EMPTY: 'Дашборд је празан',
    DASHBOARD_HINT: 'Почните са вашим надзорним таблама прављењем таблица.',
    YEARS_SETTINGS: 'Подешавања година',
    FINANCIAL_YEAR_STARTING_MONTH: 'Почетак финансијске године месец',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Ажурирање почетног месеца финансијске године',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Почетни месец финансијске године ажуриран',
    SOMETHING_WENT_WRONG: 'Дошло је до грешке.',
    SEARCH_FOR_USERS: 'Претражите кориснике...',
    SEARCH_FOR_GROUPS: 'Претражите групе...',
    SEARCH_BY_GROUP_OR_USER: 'Претражи по групи или кориснику',
    USERS: 'Корисници',
    GROUPS: 'Групе',
    USER_OR_GROUP: 'Корисник/Група',
    PERMISSIONS: 'Дозволе',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Крајњи датум мора бити већи од почетног датума',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Историјски подаци не могу се преклапати са подацима прогнозе',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Молимо изаберите ознаку рачуна',
    ERROR_STARTING_FORECAST: 'Грешка при покретању прогнозе',
    CUSTOM_FORECAST: 'Прилагођена прогноза',
    HISTORICAL_DATA_FROM: 'Историјски подаци од',
    HISTORICAL_DATA_TO: 'Историјски подаци до',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Извор варијабла и димензије',
    ERROR: 'Грешка {message}',
    FORECAST: 'Прогноза',
    VIEW_FORECASTS_FOR_PERIOD: 'Прикажи прогнозе за период',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Нема послова за одабрани период',
    ACTIVE_JOBS: 'Активни послови',
    FINISHED_JOBS: 'Завршени послови',
    COMPLETED_ON: 'Завршено у {time}',
    FORECAST_PROGRESS: 'Напредак и историја прогнозе',
    ERROR_LOADING_FORECAST_JOBS: 'Грешка при учитавању послова прогнозе.',
    PAGE: 'Страница',
    EDIT_ENTRY: 'Уреди унос',
    NEW_ENTRY_BY_DATE: 'Нови унос по датуму',
    TAGS: 'Ознаке',
    ADD_TAG: 'Додај ознаку',
    START_YEAR: 'Почетна година',
    START_MONTH: 'Почетни месец',
    END_YEAR: 'Завршна година',
    END_MONTH: 'Завршни месец',
    MUST_SELECT_ROW: 'Морате изабрати ред',
    TITLE: 'Наслов',
    SUBTITLE: 'Поднаслов',
    FOOTNOTES: 'Фусноте',
    ROW: 'Ред',
    SELECT_ROW: 'Изаберите ред',
    COLUMN: 'Колона',
    ROW_NAME_DISPLAY: 'Приказ имена реда',
    BOTH: 'Оба',
    SHARED_COLUMN_CONFIG_PRESET: 'Заједничка конфигурација стуба',
    SHOW_ZERO_SUM_ROWS: 'Приказ нуле сумираних редова',
    USE_DATA_FROM_TIMELINE_SLICER: 'Користите податке из временског сечења',
    USE_DATA_FROM_DIMENSION_SLICER: 'Користите податке из сечења димензије',
    DELETE_TARGET_AND_RELATED_DATA: 'и повезани подаци?',
    DELETE_TARGET_CHILDREN: 'Избриши децу',
    DELETE_TARGET_DATA: 'Избриши податке за',
    CONFIRM_DELETE_ROW: 'Избрисати ред?',
    CONFIRM_DELETE_ROWS: 'Избрисати {count} редова?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Избрисати генерисане редове?',
    CONFIRM_DELETE_ROWS_MIXED: 'Избрисати редове и генерисане редове?',
    EXPLAIN_DELETE_ROW: 'Ово ће избрисати <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'Ово ће избрисати генерисане редове из <>{table}<> са ове табеле.',
    EXPLAIN_DELETE_ROWS_MIXED: 'Ово ће избрисати <>{count} ред(ова)<> и генерисане редове из <>{table}<> са ове табеле.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'Ово ће такође избрисати све потпоткројене редове. Ова радња се не може поништити.',
    FAILED_DELETE_ROW: 'Није успело брисање реда',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'и све његове подредне редове и ставке?',
    NO_ACCESS_TO_DELETE_ROWS: 'Немате приступ наведеним редовима, па их не можете избрисати.',
    CREATE_GROUP: 'Направи групу',
    EDIT_PERMISSIONS: 'Уреди дозволе',
    USERS_AND_GROUPS_MANAGEMENT: 'Управљање корисницима и групама',
    SUM: 'Збир',
    COUNT: 'Број',
    AVERAGE: 'Процјена',
    CLOSING_STATE: 'Затварање стања',
    BEGINNING_STATE: 'Почетно стање',
    FORMULA: 'Формула',
    MAX: 'Максимум',
    MIN: 'Минимум',
    YES: 'Да',
    NO: 'Не',
    YESTERDAY: 'Јуче',
    CONFIRM_VARIABLE_REMOVE: 'Потврдите уклањање променљиве',
    CONFIRM_VARIABLES_REMOVE: 'Потврдите уклањање променљивих',
    REMOVE_VARIABLE_CONFIRMATION: 'Да ли сте сигурни да желите уклонити променљиву',
    REMOVE_VARIABLES_CONFIRMATION: 'Да ли сте сигурни да желите уклонити променљиве',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Да ли сте сигурни да желите уклонити {tagNumber} променљиве?',
    EDIT_VARIABLE: 'Уреди променљиву',
    SHARE_VARIABLE: 'Подели променљиву',
    DELETE_VARIABLE_DATA: 'Избриши податке променљиве',
    DELETE_VARIABLE: 'Избриши променљиву',
    EXPAND_MORE: 'Прошири више',
    COLLAPSE_ALL: 'Склопи све',
    SCROLL_TO_BOTTOM: 'Померите се до дна',
    VARIABLE_METRICS: 'Метрике променљиве',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Име',
        Description: 'Опис',
        Formula: 'Формула',
        Dimensions: 'Димензије',
        'Read-only': 'Само за читање',
        'Roll-up type': 'Тип укључивања',
    },
    LOADING_DATA: 'Учитавање података…',
    SUCCESSFULLY_LOADED_DATA: 'Подаци учитани',
    LOADING_DATA_FAILED: 'Није могуће учитати податке',
    LOADING_DATA_FAILED_SUBTITLE: 'Покушајте да освежите страницу',
    WAITING: 'Чекање...',
    VIEW_LOGS: 'Прикажи записе',
    LOADING_DATA_LOG: 'Лог учитавања података',
    CALCULATION_STARTED: 'Почетак израчунавања',
    CALCULATION_FINISHED: 'Израчунавање завршено',
    DATABASE_LOADED: 'База података учитана. Број учитаних ћелија: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Почело израчунавање променљиве {variableName}. Број улазних ћелија: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Израчунавање променљиве {variableName} завршено. Број ћелија: {numberOfCells}, од/у фактор: {outInFactor}.',
    NEW_ROW: 'Нови ред',
    NEW_TEMPLATE_OR_ROW: 'Ново',
    ADD_TEMPLATE_TO_TOOLBAR: 'Додај на траку алата',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Уклони са траке алата',
    IN_TOOLBAR: 'На траци алата',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Шаблон додат на траку алата',
    TEMPLATES: 'Шаблони',
    SELECT_A_ROW: 'Изабери ред',
    FILE_CANT_BE_PREVIEWED: 'Датотека се не може прегледати',
    THIS_TYPE_OF: 'Овај тип',
    INPUT_SETUP: 'Поставке улаза',
    ONDEMAND_CALCULATION: 'Прорачун по захтеву',
    REFRESH_DATA: 'Освежи податке',
    DISABLE_MAINTENANCE_MODE: 'Онемогући режим одржавања',
    ENABLE_MAINTENANCE_MODE: 'Омогући режим одржавања',
    SAVED: 'Сачувано',
    FORMULA_ERROR: 'Грешка у формули',
    UNEXPECTED: 'Неочекивано',
    INVALID_SYNTAX: 'Неисправан синтакса за',
    MISSING_TOKEN_AFTER: 'Недостаје токен после',
    UNNECESSARY: 'Непотребно',
    ERROR_MESSAGE_OCCURRED: 'Дошло је до грешке',
    INCOMPLETE_sheet_ITEM_DATA: 'Непотпуни подаци о ставкама',
    FAIL_SAVE_sheet_ITEMS: 'Није успјело сачувати ставке',
    HEADER_COLUMNS: {
        Description: 'Опис',
        Date: 'Датум',
        Version: 'Верзија',
        'Variable and Dimensions': 'Променљива и димензије',
        Value: 'Вредност',
        'Value type': 'Врста вредности',
        Action: 'Акција',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Ажурирање описа за месец и годину до ознака није успело.',
    COMPARISON: 'Поређење',
    DISALLOW: 'Забранити',
    USE_DEFAULT: 'Користите подразумевано',
    SKIP_ROW: 'Прескочи ред',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Неће дозволити увоз док постоје непостојећи чланови.',
    MISSING_MEMBERS_SKIP_ROWS: 'Прескочи редове са непостојећим члановима.',
    MISSING_MEMBERS_DEFAULT: 'Увези податке из непостојећих чланова у подразумеваног члана табеле.',
    CONFIGURE_JOB_OPTIONS: 'Подесите опције задатка',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Управљајте недостајећим члановима димензије',
    IMPORT_ZEROS: 'Увоз нула',
    OVERWRITE_CELLS: 'Преписати ћелије',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Игноришите померање финансијске године',
    SKIP_EMPTY_ROWS: 'Прескочи празне редове',
    SKIP_REPEATING_HEADER_ROWS: 'Прескочи понављајуће редове заглавља',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Прескочи редове са слабим сигналом (хеуристика)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: '{count} ред(ова) ће бити прескочен(о) при увозу.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Ниједан ред неће бити прескочен при увозу.',
    INCLUDE_IN_IMPORT: 'Укључи у увоз',
    EXCLUDE_FROM_IMPORT: 'Искључи из увоза',
    MISSING_MEMBERS_REPLACE_ALL: 'Замените све претходне чланове димензије',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Да ли сте сигурни да желите заменити све претходне чланове димензије?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Примени чланове и променљиве на вредносне колоне',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Добијен је погрешан тип резултата за колону {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Покушано је додавање непостојећих ознака',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Покушано је стварање ознаке са празним именом',
    NO_PARENT_TAG_SELECTED: 'Није изабран родитељски таг',
    COLUMN_MANAGER: 'Колоне',
    NO_COLUMNS: 'Нема колона.',
    NEW_COLUMN_TIP: 'Можете почети додавањем новог елемента колоне. Затим користите бочну траку за избор и креирање прилагођених колона.',
    NEW_COLUMN: 'Нова колона',
    COLUMN_TO_NUMBER_TYPE: 'Промени у број',
    COLUMN_TO_COMPARISON_TYPE: 'Промени у поређење',
    COMPARISON_OPERATION: 'Операција',
    DROP_ELEMENTS: 'Пошаљи елементе...',
    READONLY: 'Само за читање',
    CUSTOM_TITLE: 'Прилагођен наслов',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Изаберите ред за отпремање елемената',
    CANT_MOVE_ROW_INSIDE_SELF: 'Не можете преместити ред унутар самог себе',
    CLEAR_ALL: 'Очистити све',
    MIGRATE_TO_SHEET: 'Мигрирај на лист',
    CHOOSE_TIME_PERIOD: 'Молим вас одаберите временски период',
    NO_VARIABLE: 'Нема варијабле',
    NO_ROWS_SELECTED: 'Нема одабраних редова',
    STARTING_YEAR_NOT_ACTIVE: 'Почетна година није активна',
    SHEET: 'Лист',
    ASSIGNEE: 'Додељени',
    APPROVER: 'Одобравач',
    SHARED_TO: 'Делјено са',
    PUBLIC: 'Јавно',
    PUBLIC_LINK: 'Јавна веза',
    VERSIONS_AND_INTERVAL: 'Верзије и интервал',
    INTERVAL: 'Интервал',
    EXPIRES_IN: 'Истиче за',
    STATUS: 'Статус',
    STATUS_EXPIRES_IN: 'Статус (Истиче за)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Веза јавног задатка копирана у међуспремник',
    EXPORTING: 'Извоз...',
    APPROVE: 'Одобри',
    DISAPPROVE: 'Одбиј',
    EXPORT: 'Извези',
    EXPIRE: 'Истекни',
    REFRESH: 'Освежи',
    NO_ASSIGNMENTS_AVAILABLE: 'Нема доступних задатака',
    MARK_IN_REVIEW: 'Означи као у прегледу',
    MARK_AS_UNRESOLVED: 'Означи као нерешено',
    MARK_AS_RESOLVED: 'Означи као решено',
    GO_TO_ROW: 'Иди на ред',
    DELETE_THREAD: 'Избриши нит',
    REPLAY_OR_TAG_IN_COMMENT: 'Одговори или означи друге с @...',
    COMMENT_OF: 'Коментар {arrowsCurrent} од {arrowsAll}',
    COMMENT: 'Коментар',
    COMMENTS: 'Коментари',
    LOADING_IMPORT_JOBS: 'Учитавање послова увоза',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Скуп података је превелик за потпуни приказ. Приказано је само првих 200.000 редова. Сви редови ће бити увезени када потврдите.',
    SELECTED_JOB_DOESNT_EXIST: 'Одабрани посао не постоји',
    GO_BACK_TO_IMPORT: 'Врати се на увоз',
    BACK_TO_IMPORT: 'Назад на увоз',
    AT_LEAST_ONE_CHART_LINE: 'Морате додати барем једну линију графикона.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Морате додати барем једну ознаку оси x',
    VISUALIZATION_TYPE: 'Тип визуализације',
    VISUALISATION_OPTIONS: 'Опције визуализације',
    EDIT_CHART: 'Уређивање графикона "{title}"',
    BAR_CHART: 'Стубичасти графикон',
    BAR: 'Стубац',
    STACKED_BAR_CHART: 'Наслагани стубичасти графикон',
    STACKED_BAR: 'Наслагани стубац',
    WATERFALL_CHART: 'Водопадни графикон',
    WATERFALL: 'Водопад',
    PIN_CHART: 'Чиода графикон',
    PIN: 'Чиода',
    AREA_CHART: 'Површински графикон',
    AREA: 'Површина',
    STACKED_AREA_CHART: 'Наслагани површински графикон',
    STACKED_AREA: 'Наслагана површина',
    LINE_CHART: 'Линијски графикон',
    LINE: 'Линија',
    COMBO_CHART: 'Комбиновани графикон',
    PIE_CHART: 'Тортни графикон',
    TRAFFIC_LIGHT: 'Семафор',
    INDICATOR: 'Показивач',
    SINGLE_VALUE: 'Појединачна вредност',
    CREATE_CHART: 'Створи нови графикон',
    ORIENTATION_LAYOUT: 'Оријентација и распоред',
    HORIZONTAL: 'Хоризонтално',
    VERTICAL: 'Вертикално',
    SINGLE: 'Појединачно',
    GRID: 'Мрежа',
    THIN: 'Танко',
    THICK: 'Дебело',
    DOUBLE: 'Двоструко',
    DOT: 'Тачка',
    CIRCLE: 'Круг',
    SQUARE: 'Квадрат',
    CATEGORY_AXIS: 'Оса категорија',
    DOMAIN_AXIS: 'Оса домена',
    SHOW_TOTALS: 'Прикажи укупне вредности',
    SHOW_AXIS: 'Прикажи осу',
    SHOW_VALUE_AXIS: 'Прикажи осу вредности',
    SHOW_CATEGORY_AXIS_LABELS: 'Прикажи ознаке осе категорија',
    COMPACT_AXIS_LABELS: 'Компактне ознаке оса',
    CATEGORY_LABEL_ANGLE: 'Угао ознаке категорије',
    LABEL_FORMAT: 'Формат ознаке',
    SHOW_LEGEND: 'Прикажи легенду',
    SHOW_INTEGRATED_LEGEND: 'Прикажи интегрисану легенду',
    VALUE_LABELS: 'Ознаке вредности',
    ROW_VALUE_LABELS: 'Ознаке вредности редова',
    SHOW_VALUE_LABELS: 'Прикажи ознаке вредности',
    POSITION: 'Позиција',
    SMART_FILTERING: 'Паметно филтрирање',
    TRANSPOSE_DATA: 'Користи колоне као серије',
    NORMALIZE_TO_PERCENT: 'Нормализуј на 100%',
    SHOW_EMPTY_ROWS: 'Прикажи празне редове',
    SHOW_EMPTY_COLUMNS: 'Прикажи празне колоне',
    GROUP_BY_PARENT_ROW: 'Груписање по родитељском реду',
    ACCUMULATE_DATA: 'Израчунај текући збир',
    COLOR_BY_VALUE: 'Боја на основу вредности',
    COLOR_BY_TREND: 'Обој према тренду',
    COLOR_TOTALS_BY_VALUE: 'Обоји укупне вредности према вредности',
    THRESHOLD_VALUE: 'Вредност прага',
    USE_SHARED_SCALE: 'Користи заједничку скалу',
    STATIC: 'Статично',
    BY_VALUE: 'Према вредности',
    BY_TREND: 'Према тренду',
    BAR_SPACING: 'Размак стубаца',
    GAP: 'Размак',
    WIDTH: 'Ширина',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Користи податке из резача димензија',
    X_AXIS_DIMENSION_BUILDER: 'Градитељ димензија осе X',
    ADD_REMOVE_X_AXIS_COLUMN: 'Додај/уклони колону осе x',
    Y_AXIS_ITEMS: 'Ставке оси Y',
    ADD_CHART_LINE: 'Додај линију графикона',
    UNLOCK_HIERARCHY: 'Откључај хијерархију',
    LOCK_HIERARCHY: 'Закључај хијерархију',
    MATERIALIZE: 'Материјализуј',
    MORE_OPTIONS: 'Више опција',
    LOCK_ROW: 'Закључај ред',
    LOCK_COLUMN: 'Закључај колону',
    PASTE: 'Залепи',
    COPY: 'Копирај',
    CUT: 'Исеци',
    PASTE_ROWS: 'Залепи ред(ове)',
    COPY_ROWS: 'Копирај ред(ове)',
    CUT_ROWS: 'Исеци ред(ове)',
    MOVING_ROWS: 'Премештање редова...',
    PASTING_ROWS: 'Лепљење редова...',
    CONFIRM_LOCK: 'Потврди закључавање',
    CONFIRM_UNLOCK: 'Потврди откључавање',
    CONFIRM_LOCK_AND_CHILDREN: 'Јесте ли сигурни да желите закључати овај ред и његове подредове?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Јесте ли сигурни да желите откључати овај ред и његове подредове?',
    SEARCH_FOR_IMPORTS: 'Претражи увозе',
    NEW_IMPORT: 'Нови увоз',
    IMPORTER: 'Увозник',
    CREATION_DATE: 'Датум стварања',
    ACTIONS: 'Радње',
    ADD_ACTION: 'Додај радњу',
    ADD_ARGUMENT: 'Додај аргумент',
    EDIT_ACTION: 'Уреди радњу',
    ACTION_NAME: 'Назив радње',
    ARCHIVE: 'Архивирај',
    REPLACE: 'Замени',
    STATUS_MESSAGE_MAP: {
        'In progress': 'У току',
        Commited: 'Започето',
        Archived: 'Архивирано',
        Reverted: 'Враћено',
    },
    EDIT_TILE: 'Уреди плочицу',
    FOCUS_TILE: 'Фокусирај елемент',
    UNFOCUS_TILE: 'Поништи фокус елемента',
    MOVE_TO: 'Премести у',
    ADD_ROW: 'Додај ред',
    ADD_COLUMN: 'Додај колону',
    EDIT_ROW: 'Уреди ред',
    FROM: 'Од',
    TO: 'До',
    GLOBAL_FORMATTING: 'Глобално форматирање',
    FAIL_SAVE_CHANGES: 'Неуспешно чување промена.',
    TAG_NAME_EXISTS: 'Име ознаке већ постоји.',
    MUST_CHOOSE_TYPE: 'Морате одабрати врсту',
    MUST_ENTER_TAG_NAME: 'Морате унети име ознаке',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Име ознаке не може садржати наводнике.',
    INVALID_VARIABLE_TAG_FORMAT: 'Невалидан формат ознаке варијабле: {tagFormat}',
    INVALID_FORMULA: 'Невалидна формула.',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Функција {image} није дозвољена на ознакама димензија.',
    CREATE_DATABASE_OBJECT: 'Креирај објекат базе података',
    EDIT_TAG_TYPE_NAME: 'Уреди {tagType} "{tagName}"',
    PARENT: 'Родитељ',
    ROOT: 'Корен',
    SEARCH_OR_SELECT_PARENT_TAG: 'Претрађи или одабери ознаку родитеља',
    ROLLUP_TYPE: 'Тип сабирања',
    DATA_TYPE: 'Тип података',
    FORMAT_TYPE: 'Тип формата',
    CHOOSE_FORMATTING_OPTION: 'Одаберите опцију форматирања',
    ENTER_CUSTOM_FORMAT: 'Унесите прилагођени формат',
    CUSTOM_FORMAT: 'Прилагођени формат',
    TOP_DOWN: 'Од врха према дну',
    TOP_DOWN_DATA_MAPPING: 'Мапа података од врха према дну',
    CONNECTED: 'Повезан',
    ADD_CONNECTED_VARIABLE: 'Додај повезану варијаблу',
    REVERSE_CONNECTED: 'Обрнуто повезано',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Додај обрнуто повезану варијаблу',
    DIMENSIONS: 'Димензије',
    ADD_DIMENSION: 'Додај димензију',
    ADVANCED: 'Напредно',
    CALCULATE_ON_DEMAND: 'Израчунавај по потреби',
    TRIGGER_ON_DEMAND_CALCULATION: 'За покретање израчунавања по потреби, идите на "Input Setup"',
    OPTIMIZE_CALCULATION: 'Оптимизуј израчунавање',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Ограничени лагани одозго према доле',
    USE_HIERARCHY_IN_CALCULATION: 'Користи хијерархију у израчуну',
    MAPPING_TO_VARIABLE: 'Мапирање на променљиву',
    ADD_FROM_VERSION: 'Додај из верзије',
    MAPPING_FROM_VERSION: 'Мапирање из верзије',
    MAPPING_TO_VERSION: 'Мапирање на верзију',
    ADD_TO_VERSION: 'Додај у верзију',
    USED_IN_FORMULA: 'Користи се у 1 формули',
    USED_IN_FORMULAS: 'Користи се у {numberOfTags} формула',
    TABLE_BACKLINKS: 'Референцирано из {{1 табеле|?? табела}}',
    VARIABLE_BACKLINKS: 'Користи се у {{1 променљивој|?? променљивих}}',
    ACTIVE: 'Активан',
    CONNECTED_DIMENSION: 'повезану димензију',
    MY_ACCOUNT: 'Мој налог',
    SIGN_OUT: 'Одјава',
    LOG_OUT: 'Одјава',
    EDIT_PROFILE: 'Уреди профил',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    PROFILE_AND_SUPPORT: 'Профил и подршка',
    RENAME_TABLE: 'Преименуј табелу',
    SHARE_TABLE: 'Подели табелу',
    DELETE_TABLE_DATA: 'Избриши податке у табели',
    DELETE_TABLE_MEMBERS: 'Избриши чланове табеле',
    DELETE_TABLE_DIMENSIONS: 'Избриши димензије табеле',
    DELETE_TABLE: 'Избриши табелу',
    DELETE_ROW: 'Избриши ред',
    DELETE_ROWS: 'Избриши ред(ове)',
    SHOW_VALUE: 'Прикажи вредност',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Прикажи променљиве и димензије',
    FREEZE_PANES: 'Замрзни окна',
    FREEZE_UP_TO_THIS_ROW: 'Замрзни до овог реда',
    FREEZE_UP_TO_THIS_COLUMN: 'Замрзни до ове колоне',
    UNFREEZE_ROWS: 'Одмрзни редове',
    UNFREEZE_COLUMNS: 'Одмрзни колоне',
    HIDE_GRIDLINES: 'Сакриј мрежне линије',
    HIDE_ROW_COLUMN_HEADERS: 'Сакриј заглавља редова/колона',
    LABELS: 'Ознаке',
    ADD_LABEL: 'Додај ознаку',
    ERROR_LABEL_EXISTS: 'Ознака већ постоји!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Грешка при преименовању ознаке увозног посла!',
    IMPORT_JOB_LABEL_RENAMED: 'Ознака увозног посла преименована',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Грешка при брисању ознаке увозног посла!',
    IMPORT_JOB_LABEL_DELETED: 'Ознака увозног посла обрисана',
    CREATE_OR_SEARCH: 'Креирај или претражи..',
    CREATE: 'Креирај',
    NAME_AND_DESCRIPTION: 'Име и опис',
    SUBTOTALS: 'Међусуме',
    TOTAL: 'Укупно',
    DISABLED: 'Онемогућен',
    BEFORE: 'Пре',
    AFTER: 'После',
    UNSELECT_ALL: 'Поништи све',
    SAVE_CONFIG_FOR_ALL: 'Сачувај за све',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Сачувај измене конфигурације као подразумеване',
    EDIT_DIMENSION_SLICER: 'Уређивање димензионог слоја "{title}"',
    CREATE_DIMENSION_SLICER: 'Креирај нови димензиони слој',
    ENABLE_MULTISELECT: 'Омогући вишеструки избор',
    DISPLAY_MULTIPLE_VALUES: 'Прикажи вишеструке вредности',
    SEARCH_AND_AUTO_SELECT: 'Претражи и аутоматски изабери',
    BLANKS: '(Празно)',
    ENTER_TITLE: 'Унесите наслов...',
    TAG_NAME_DISPLAY: 'Приказ имена ознаке',
    FILTERS: 'Филтери',
    ADD_FILTER: 'Додај филтер',
    BY_DIMENSION: 'По димензијама',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Прикажи само димензије са подацима',
    EDIT_SINGLE_VALUE: 'Уређивање појединачне вредности "{title}"',
    CREATE_SINGLE_VALUE: 'Креирај нову појединачну вредност',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Остави празно за аутоматско генерисање',
    FILTER_DIMENSIONS: 'Филтрирај димензије',
    COMPARISON_DIMENSIONS: 'Димензије за поређење',
    COMPARISON_CUSTOM_TEXT: 'Прилагођени текст за поређење',
    DATA_ENTRY: 'Унос података',
    SHOW_BUTTONS: 'Прикажи дугмади',
    STEP: 'Корак',
    AND: 'и',
    DOWNSTREAM_FILTERS: 'Филтри низводно',
    TO_TABLE: 'У табелу',
    FROM_TABLE: 'Из табеле',
    ADD_DOWNSTREAM_FILTER: 'Додајте низводни филтер',
    FLAT: 'Равно',
    HIERARCHY_MAX_DEPTH: 'Максимална дубина хијерархије',
    APPLICATION_VERSION: 'Верзија апликације',
    CONFIRM_TAG_REMOVE: 'Потврди уклањање ознаке',
    CONFIRM_TAGS_REMOVE: 'Потврди уклањање ознака',
    REMOVE_TAG_CONFIRMATION: 'Да ли сте сигурни да желите да уклоните ознаку {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Да ли сте сигурни да желите да уклоните ознаке: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Да ли сте сигурни да желите да уклоните {tagNumber} ознака?',
    ERROR_PARSING_NUMBER: 'Грешка приликом парсирања броја',
    ERROR_PARSING_DATE: 'Грешка приликом парсирања датума',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Молимо користите контекстни мени за ажурирање колоне датотеке',
    ERROR_PARSING_INPUT_NUMBER: 'Грешка приликом парсирања уносног броја',
    ERROR_SAVING_DATA: 'Грешка приликом чувања података',
    DATA_ENTRY_NOT_ALLOWED: 'Унос података није дозвољен',
    ERROR_PARSING_STEP_VALUE: 'Грешка приликом парсирања вредности корака',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} ћелија',
    UNKNOWN_VARIABLE_CELLS: 'Непозната променљива: {cellNumber} ћелија',
    SUCCESS_IMPORTED_CELLS: 'Успех! Увезено ћелија: {accountTags}',
    IMPORTED_CELLS: 'Увезено ћелија',
    IMPORT_JOB_DELETING: 'Брисање увозног посла',
    IMPORT_JOB_DELETING_CONFIRM: 'Да ли сте сигурни да желите обрисати увозни посао {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Обрисати и задржати податке',
    DELETE_JOB_AND_DATA: 'Обрисати посао и податке',
    ADD_DIMENSIONS_TO_JOB: 'Додај димензије послу',
    CONFIGURE: 'Конфигурисати',
    ADD_DESCRIPTION_FOR_IMPORT: 'Додај опис за овај увоз',
    UNDO: 'Поништи',
    SETTINGS: 'Поставке',
    BASIC_SETTINGS: 'Основна подешавања',
    OTHER_SETTINGS: 'Остала подешавања',
    TABLE_NAME: 'Име табеле',
    AUTOGENERATE_DIMENSION_NAMES: 'Аутогенерисање имена димензија',
    AUTOGENERATE_NAMES_CONFIG: 'Конфигурација аутогенерисања имена',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'нпр. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Дефинишите прилагођену конфигурацију за аутоматско генерисање имена за ову табелу. Користите предефинисане ознаке испод са витичастим заградама. Можете ставити било који знак између ознака.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Можете користити ове ознаке за дефинисање конфигурације',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (ožujka 20, 2023.)',
    ENTRY: 'Унос',
    STEP_MUST_BE_NUMBER: 'Корак мора бити број',
    EDIT_DATA_EDITOR: 'Уређивање уређивача података "{title}"',
    BUTTON_CONTROLS: 'Контроле дугмета',
    BOLD: 'Подебљано',
    ITALIC: 'Курзив',
    UNDERLINED: 'Подвучено',
    OUTLINED: 'Обруб',
    FONT_SIZE: 'Величина фонта',
    FILE_SIZE: 'Величина датотеке',
    SMALL: 'Мало',
    MEDIUM: 'Средње',
    LARGE: 'Велико',
    CREATE_NEW_COLUMN: 'Креирај нову колону',
    EDIT_COLUMN_WITH_LABEL: 'Уреди колону "{label}"',
    COLUMN_TAGS: 'Ознаке колоне',
    DELETE_THIS_COLUMN: 'Обриши ову колону',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Изаберите родитељску ознаку за генерисање више колона',
    USING_SHARED_COLUMN_CONFIG: 'Користи заједничку конфигурацију колоне',
    SLICER_GENERATED: 'Слицер генерисан',
    HEADER_CANNOT_BE_EMPTY: 'Заглавље не може бити празно',
    MUST_CHOOSE_A_FORMAT: 'Морате изабрати формат',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Поља за израчунавање не могу бити празна',
    ADD_NEW_COLUMN: 'Додај нову колону',
    HEADER: 'Заглавље',
    SUBHEADER: 'Поднаслов',
    TYPE: 'Тип',
    POLARITY: 'Поларитет',
    CONDITIONAL_FORMATTING: 'Условно форматирање',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Релативно',
        Absolute: 'Апсолутно',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Позитивно',
        Negative: 'Негативно',
        Neutral: 'Неутрално',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Регуларно',
        Calculated: 'Израчунато',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Искључено',
        Traffic: 'Светла за саобраћај',
        Databar: 'Трака података',
        Colorscale: 'Скала боја',
        Arrows: 'Стрелице',
    },
    HIDE_NUMBERS: 'Сакриј бројеве',
    COLUMN_ONE: 'Колона 1',
    COLUMN_TWO: 'Колона 2',
    LITERAL: 'дослован',
    FUNCTION: 'функција',
    FUNCTIONS: 'Функције',
    EXAMPLE: 'Пример',
    EDIT_IN: 'Уреди {type}',
    OPEN_IN_EDITOR: 'Отвори у {type} уређивач',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Сваке недеље у {day} у {time}',
    REMOTE_JOB_SCHEDULED: 'Заказано {schedule}',
    SCHEDULE: 'Распоред',
    EVERY: 'Сваки',
    EVERY_HOUR_AT: 'Сваки сат у',
    EVERY_DAY_AT: 'Сваки дан у',
    RUN_JOB: 'Покрени посло',
    RUN: 'Покрени',
    QUEUED: 'На чекању',
    RUNNING: 'Извршавање...',
    UNAVAILABLE: 'Недоступно',
    MINUTES: 'минута',
    JOBS: 'Послови',
    JOB_LOGS: 'Дневници послова',
    PREFERRED_RUNNER: 'Приоритетни извођач',
    RUNNER_DISCONNECTED: 'Овај извођач тренутно није повезан.',
    RUNNER_IMAGE: 'Слика извођача',
    RUNNER_IMAGE_TAG: 'Верзија',
    LOGS: 'Дневници',
    REMOTE_JOBS: 'Апликације',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Верзија',
        Year: 'Година',
        Month: 'Месец',
        Quarter: 'Квартал',
        'Half Year': 'Полугодиште',
        'Year to Date': 'Од почетка године',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Варијабла/Табела/Димензија/Група',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Додај нови {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Цео број',
        Decimal: 'Децимала',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Прилагођено',
        Number: 'Број',
        Currency: 'Валута',
        Percentage: 'Проценат',
        Date: 'Датум',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Контролна табла',
        Sheets: 'Табеле',
        Import: 'Увоз',
        'Remote jobs': 'Апликације',
        Dimensions: 'Димензије',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Табела димензија',
        DIMENSION_MEMBER: 'Члан димензије',
        VARIABLE: 'Променљива',
        FOLDER: 'Фасцикла',
        FUNCTION: 'Функција',
        LITERAL: 'Литерал',
        PROPERTY: 'Својство',
        FILE: 'Датотека',
        DASHBOARD: 'Контролна табла',
        REMOTE_JOB: 'Апликација',
        SHEET: 'Табела',
        TILE: 'Плочица',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Табеле димензија',
        DIMENSION_MEMBER: 'Чланови димензија',
        VARIABLE: 'Променљиве',
        FOLDER: 'Фасцикле',
        FUNCTION: 'Функције',
        LITERAL: 'Литерали',
        PROPERTY: 'Својства',
        FILE: 'Датотеке',
        DASHBOARD: 'Контролне табле',
        REMOTE_JOB: 'Апликације',
        SHEET: 'Табеле',
        TILE: 'Плочице',
    },
    ITEM: 'Ставка',
    ITEM_TYPE: 'Врста ставке',
    FOLDER_ITEM: {
        DASHBOARD: 'Контроле',
        DIMENSION_TABLE: 'Табеле димензија',
        VARIABLE: 'Променљиве',
        SHEET: 'Табеле',
        FOLDER: 'Фасцикли',
        FARSEER_FILE: 'Датотеке',
        REMOTE_JOB: 'Апликације',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Контроле',
        DIMENSION_TABLE: 'Табеле димензија',
        VARIABLE: 'Променљиве',
        SHEET: 'Табеле',
        FOLDER: 'Фасцикли',
        FARSEER_FILE: 'Датотеке',
        REMOTE_JOB: 'Апликације',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'генерише универзални јединствени идентификатор',
        YYYY: 'уметне текућу годину',
        YY: 'уметне последње две цифре текуће године',
        MM: 'уметне текући месец',
        DD: 'уметне текући дан',
        SSSSSSSS: 'уметне серијски број дужине тренутне табеле + 1, дефинишите дужину према броју карактера "S" (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Корисници и дозволе',
        'Users & Groups': 'Корисници и групе',
        System: 'Систем',
        'Input Setup': 'Подешавање уноса',
        Locks: 'Закључавање',
        'Backup & Restore': 'Бекап и обнова',
        'Audit Logs': 'Дневници',
        'Export Model': 'Извоз модела',
        'Import Model': 'Увоз модела',
        'Switch Tenants': 'Промена радног простора',
        Support: 'Подршка',
        'Help Center': 'Центар за помоћ',
        'Contact Support': 'Контактирајте подршку',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'минус',
        divide: 'делить',
        plus: 'плус',
        multiply: 'умножити',
        percent: 'процент',
        'percent thousands': 'процент хиљада',
        'difference in %': 'разлика у %',
    },
    STATUS_MAP: {
        Resolved: 'Решено',
        Unresolved: 'Нерешено',
        'In Review': 'У прегледу',
        QUEUED: 'У реду',
        RUNNING: 'У извршавању',
        FINISHED: 'Завршено',
        ERROR: 'Грешка',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Креирај корисника',
        'Delete User': 'Обриши корисника',
        'Find All Users': 'Пронађи све кориснике',
        'Get User': 'Дохвати корисника',
        'Update User': 'Ажурирај корисника',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Објекти базе података у моделу',
        CLUSTER_FLOW_ADD: 'Додавање реда',
        YEAR_VERSION_LOCKS: 'Закључавања',
        IMPORT: 'Увоз',
        SEE_ALL_IMPORT_JOBS: 'Прикажи све увозне послове',
        USERS_GROUPS_MANAGEMENT: 'Управљање корисницима и групама',
        REMOTE_JOBS: 'Апликације',
        COMMENTS: 'Коментари',
        TAGS_SIDEBAR: 'Трака са базама података',
        CREDENTIALS: 'Пријавнице',
        INPUT_SETUP: 'Постављање уноса',
        AUDIT_LOGS: 'Прегледање дневника надзора',
        ASSIGNMENTS: 'Задаци',
        BACKUP_AND_RESTORE: 'Бекап и обнова',
        DASHBOARD_TO_IMAGE: 'Извоз дашборда у слику',
        CHAT_AI: 'Разговор AI',
        DELETE_DIMENSION: 'Избриши димензију',
        FORECAST: 'Прогноза',
        GOAL_SEEKING_TOP_DOWN: 'Тражење циља од врха према доле',
        MODEL_IMPEX: 'Увоз/извоз модела',
        OWD_MEASURES: 'Само са подацима за мере',
        FORMULA_QA: 'Формула QA',
        USE_HIERARCHY_IN_CALCULATION: 'Ажурирај "користи хијерархију" у променљивим',
        MODEL_HEALTH: 'Здравље модела',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Farseer лого',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Уреди ћелије',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Креирај фасциклу',
        'Duplicate Folder': 'Дуплирај фасциклу',
        'Search Folders': 'Претрага фасцикли',
        'Get Items in Folder': 'Дохвати ставке у фасцикли',
        'Find by Reverse References': 'Пронађи по обрнутим референцама',
        'Move Items': 'Премести ставке',
        'Rename Items': 'Преименуј ставке',
        'Delete Items in Folder': 'Обриши ставке из фасцикле',
        'Share Folder Hierarchy': 'Подели хијерархију фасцикле',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Креирај објекат базе података',
        'Delete Database Object': 'Обриши објекат базе података',
        'Get Database Object': 'Дохвати објекат базе података',
        'Update Database Object': 'Ажурирај објекат базе података',
        'Search Database Objects': 'Претражи објекте базе података',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Креирај лист',
        'Get Sheet': 'Дохвати лист',
        'Update Sheet': 'Ажурирај лист',
        'Duplicate Sheet': 'Дуплирај лист',
        'Search Rows in Sheet': 'Претражи редове у листу',
        'Get Sheet Data': 'Преузми податке о листу',
        'Set Sheet Data': 'Постави податке о листу',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Креирај ред',
        'Update Row': 'Ажурирај ред',
        'Delete Row': 'Обриши ред',
        'Move Row': 'Премести ред',
        'Duplicate Row': 'Дуплирај ред',
        'Find All Row': 'Пронађи све редове',
        'Get Row': 'Преузми ред',
        'Materialize Row': 'Материјализуј ред',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Креирај задатак',
        'Add Public Shares': 'Креирај јавни задатак',
        'Delete Share': 'Обриши задатак',
        'Get Share': 'Преузми задатак',
        'Update Share': 'Ажурирај задатак',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Преузми ознаку',
        'Create Label': 'Креирај ознаку',
        'Update Label': 'Ажурирај ознаку',
        'Delete Label': 'Обриши ознаку',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Креирај датотеку',
        'Update File': 'Ажурирај датотеку',
        'Delete File': 'Обриши датотеку',
        'Find All Files': 'Пронађи све датотеке',
        'Get File': 'Преузми датотеку',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Креирај апликацију',
        'Update Remote Job': 'Ажурирај апликацију',
        'Find All Remote Jobs': 'Пронађи све апликације',
        'Get Remote Job': 'Преузми апликацију',
        'Run Remote Job': 'Покрени апликацију',
        'Run Remote Job As A Service': 'Покрени апликацију као услугу',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Врати резервну копију',
        'Create Backup': 'Креирај резервну копију',
        'Search Backups': 'Претражи резервне копије',
        'Download Backup': 'Преузми резервну копију',
        'Upload Backup': 'Отпреми резервну копију',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Читање модела',
        'Edit Model': 'Уређивање модела',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Креирај таблу',
        'Duplicate Dashboard': 'Дуплирај таблу',
        'Find All Dashboards': 'Пронађи све табле',
        'Get Dashboard': 'Преузми таблу',
        'Update Dashboard': 'Ажурирај таблу',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Дозвола за функцију',
        FolderClassPermission: 'Дозвола за класу фасцикле',
        TagClassPermission: 'Дозвола за класу ознака',
        SheetClassPermission: 'Дозвола за класу табеле',
        SheetRowClassPermission: 'Дозвола за класу реда табеле',
    },
    SEARCH_TAGS: 'Претражи ознаке...',
    SEARCH_PERMISSIONS: 'Претражи дозволе...',
    DEFAULT: 'Подразумевано',
    FEATURE_PERMISSIONS: 'Дозволе за функције',
    CLASS_PERMISSIONS: 'Дозволе за класове',
    ADD_COMMENT: 'Додај коментар',
    SORT: 'Сортирај',
    SORT_BY: 'Сортирај по',
    ASCENDING: 'Узлазно',
    DESCENDING: 'Силазно',
    UNSORT: 'Не сортирати',
    AUTO: 'Ауто',
    LEFT: 'Лево',
    ALL_MONTHS: 'Сви месеци',
    TWELVE_MONTHS: '12 месеци',
    YEAR_START: 'Почетак године',
    TIMELINE_START: 'Почетак временске линије',
    COPY_HASH_TAG: 'Копирај #',
    SHOW_TOP: 'Прикажи најбољих',
    SHOW_REST: 'Прикажи остатак',
    RIGHT: 'Десно',
    CENTER: 'Центар',
    TOP: 'Врх',
    MIDDLE: 'Средина',
    BOTTOM: 'Дно',
    YEAR_END: 'Крај године',
    TIMELINE_END: 'Крај временске линије',
    CURRENT_YEAR: 'Тренутна година',
    PREVIOUS_YEAR: 'Претходна година',
    CUSTOM: 'Прилагођено',
    NEW_TABLE: 'Нова {name}',
    EDIT_TABLE: 'Уреди {name}',
    FOCUS_TABLE: 'Фокусирај {name}',
    ROUND: 'Заокружи',
    REGRESSION: 'Регресија',
    RANDOM: 'Случајно',
    SET_VALUE: 'Постави вредност',
    APPLY_PERCENTAGE: 'Примени проценат',
    APPLY_PERCENTAGE_CHAR: 'Примени %',
    DELETE_COLUMNS_ON_ROW: 'Обриши колоне на реду',
    PROCESSING_FILE: 'Обрада датотеке',
    IMAGE_PREVIEW_FAILED: 'Приказ слике није успео',
    NEXT: 'Следеће',
    PREVIOUS: 'Претходно',
    PAGE_OF: 'Страница {pageNumber} од {pages}',
    NO_TITLE: 'Без наслова',
    DURATION: 'Трајање',
    CELL_COUNT: 'Број ћелија',
    NONCALCULATED: 'Неизрачунато',
    CALCULATED: 'Израчунато',
    SEARCH_ASSIGNMENTS: 'Претражи задатке',
    BY_NAME: 'По имену',
    BY_LABEL: 'По ознаки',
    BY_STATUS: 'По статусу',
    BY_SHEET: 'По табли',
    GROUP_BY: 'Груписање по',
    CHART_SPACING: 'Размак графикона',
    GRID_COLUMNS: 'Колоне мреже',
    GRID_SPACING: 'Размак мреже',
    AXIS_SPACING: 'Размак осе',
    RESET_FILTERS: 'Ресетуј филтере',
    RESET_CONFIG: 'Ресетуј конфигурацију',
    RESET_CONFIG_TOOLTIP: 'Ресетуј конфигурацију на подразумевано',
    BY_ASSIGNEE: 'По извршитељу',
    BY_APPROVER: 'По одобравању',
    NEW_ASSIGNMENT: 'Нови задатак',
    NEXT_ASSGN_DUE: 'Следећи задатак је на измаку',
    SHARE_SELECT_USER_PLACEHOLDER: 'Претражи кориснике или групе...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Креирај задатак одабиром корисника...',
    ASSIGNMENT_REFRESHED: 'Поновљен крајњи рок за завршетак задатка за 7 дана',
    CANT_EDIT_ASSIGNMENT: 'Не може се уређивати већ поднесени задаци',
    NO_CHANGES: 'Без промена',
    APPROVED: 'Одобрено',
    EXPIRED: 'Истекло',
    READY_FOR_REVIEW: 'Спремно за преглед',
    IN_PROGRESS: 'У току',
    SHARED: 'Подељено',
    SHARED_WITH: 'Подељено са',
    ARCHIVED: 'Архивирано',
    STILL_STUCK: 'Још увек сте заглављени? Посетите наш центар за помоћ.',
    NEED_HELP: 'Потребна вам је помоћ? Посетите наш центар за помоћ.',
    WELCOME: 'Добродошли',
    WELCOME_MESSAGE: 'Изаберите нешто са стране да бисте почели, или претражите нешто специфично.',
    DEFAULT_MEMBER: 'Подразумевани члан',
    FAILED_TO_LOAD_MODEL: 'Модел није учитан',
    MODEL_LOADED: 'Модел је учитан',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Ваш претходни захтев се обрађује. Молимо сачекајте...',
    RUN_ARGUMENTS: 'Покрени аргументе',
    EXPECTED_ARGUMENTS: 'Очекујемо аргументе',
    RUN_ARGUMENTS_ERROR: 'Аргументи за покретање радње су застарели, молимо да их ажурирате.',
    GENERAL: 'Општи',
    SYSTEM: 'Систем',
    BASIC_INFO: 'Основне информације',
    LAST_RUN: 'Последње покретање',
    NEVER_RUN: 'Никада није покренуто',
    REMOTE_JOB_NAME: 'Назив апликације',
    CHOOSE_FOLDER: 'Изаберите фасциклу',
    SOURCE_FOLDER: 'Изворна фасцикла',
    SELECT_SOURCE_FOLDER_WARNING: 'Молимо изаберите изворну фасциклу',
    MAIN_FILE_HINT: 'Притисните на пиљу датотеке да бисте означили скриптну датотеку као улазну тачку',
    NO_FILES: 'Нема датотека',
    NO_MAIN_FILE: 'Нема главне датотеке',
    FINDER_TOOLTIP: 'Прикажи пронађицу',
    VARIABLE_TOOLTIP: 'Прикажи траку променљивих',
    sheet_ITEMS_TOOLTIP: 'Приказ ставки таблице',
    LIST_ITEMS_TOOLTIP: 'Прикажи ставке листе',
    EXPAND_TOOLTIP: 'Прошири све редове за један ниво',
    COLLAPSE_TOOLTIP: 'Склопи све редове за један ниво',
    UNDO_TOOLTIP: 'Опозови',
    REDO_TOOLTIP: 'Понови',
    UNDO_HISTORY_RESET: 'Историја опозива је ресетована',
    UNDO_UNAVAILABLE_NOT_SUPPORTED: 'Ова промена не може да се опозове',
    UNDO_UNAVAILABLE_TOO_LARGE: 'Ова промена је превелика за опозив',
    UNDO_UNAVAILABLE_NO_INVERSE: 'Опозив више није доступан',
    UNDO_UNAVAILABLE_NO_LONGER_ALLOWED: 'Ова промена више не може да се опозове',
    UNDO_UNAVAILABLE_GENERIC: 'Ова промена не може да се опозове',
    FORECAST_TOOLTIP: 'Приказ напретка прогнозе',
    EXPORT_TOOLTIP: 'Извези у .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'Пречице апликација',
    TAGS_SIDEBAR_TOOLTIP: 'Отвори бочну траку база података',
    TILE_SIDEBAR_TOOLTIP: 'Отвори бочну траку уређивање плоче',
    COMMENTS_SIDEBAR_TOOLTIP: 'Отвори бочну траку коментари',
    ADD_APP_SHORTCUT: 'Додај пречицу',
    APP_SHORTCUTS_PATH: 'Пречице апликација',
    CHANGE_SHORTCUT_ACTION: 'Промени радњу',
    REMOVE_SHORTCUT: 'Уклони пречицу',
    SHORTCUT_ADDED: 'Пречица успешно додана',
    SHORTCUT_REMOVED: 'Пречица уклоњена',
    SHORTCUT_ALREADY_EXISTS: 'Пречица већ постоји',
    CHANGE_ACTION_TITLE: 'Промени радњу',
    CHANGE_ACTION_LABEL: 'Изаберите једну од следећих радњи',
    ACTION_CHANGED: 'Радња промењена',
    ERROR_FETCHING_APP_DATA: 'Грешка при преузимању података апликације',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Грешка при преузимању аргумената радње',
    INVALID_ACTION_ARGUMENTS: 'Невалидни аргументи радње',
    APP_STARTED_SUCCESSFULLY: 'Апликација успешно покренута',
    CREATE_BACKUP: 'Креирајте сигурносну копију',
    BACKUP: 'Сигурносна копија',
    CREATE_BACKUP_WARNING: 'Да ли сте сигурни да желите направити нову сигурносну копију?',
    RESTORE_BACKUP: 'Врати сигурносну копију',
    RESTORE: 'Врати',
    RESTORE_BACKUP_WARNING: 'Да ли сте сигурни да желите вратити се на сигурносну копију {backupPath}?',
    SELECT_MONTH: 'Изаберите месец',
    REMOVE_FILTER: 'Уклони филтер',
    FILTER_BY: 'Филтрирај по...',
    STATIC_FILTER: 'Овај филтер не може бити мењан',
    SELECT_ROW_TO: 'Изаберите ред за приказ или измјену његове променљиве',
    EDIT_ARGUMENT: 'Измени аргумент',
    ARGUMENT_NAME: 'Име аргумента',
    DATA_TYPE_STRING: 'Текст',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Подразумевана вредност',
    ADD_OPTION: 'Додај опцију',
    OPTION_VALUE: 'Вредност опције',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Опције морају бити јединствене',
    DROPDOWN_OPTION_EMPTY: 'Опција не сме бити празна',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Подразумевана вредност није изабрана — приликом чувања биће коришћена прва опција.',
    LOCKED_AT_RUN_TIME: 'Закључај вредност приликом покретања',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Када је означено, корисници приликом покретања апликације не могу променити ову вредност.',
    LOCKED_REQUIRES_DEFAULT: 'Закључани аргумент мора имати подразумевану вредност',
    SECRET: 'Тајна',
    SECRET_TOOLTIP: 'Вредност је маскирана током уноса и у логовима',
    NAME_REQUIRED: 'Име је обавезно',
    BACKUP_CREATED: 'Сигурносна копија је направљена',
    DOWNLOADING_BACKUP: 'Преузимање сигурносне копије',
    BACKUP_RESTORED: 'Сигурносна копија је враћена',
    BACKUP_SEARCH_FAILED: 'Учитавање сигурносних копија није успело. Покушајте поново.',
    UPLOAD_BACKUP: 'Учитајте сигурносну копију',
    UPLOADING: 'Учитавање',
    SHOW_UPLOADED: 'Приказано',
    INITIATED_BY: 'Покренуо',
    SAVE_AS_IMAGE: 'Сачувај као слику',
    CREATING_AND_SAVING_IMAGE: 'Креирање слике и чување у датотеке...',
    IMAGE_SAVED: 'Слика сачувана!',
    FAILED_TO_SAVE_IMAGE: 'Чување слике није успело',
    GOAL_VALUE: 'Циљна вредност',
    CURRENT_VALUE: 'Тренутна вредност',
    PERCENTAGE_MET: '{percentage}% испуњено',
    UNFREEZE_CELLS: 'Одблокирај вредности',
    FREEZE_CELLS: 'Закључај вредности',
    UNSET_GOAL: 'Уклони као циљну вредност',
    SET_GOAL: 'Постави као циљну вредност',
    INSPECT_VALUE: 'Инспекција вредности',
    EDITING_TILE: 'Уређивање табле',
    NO_TILE_SELECTED: 'Молимо изаберите таблу.',
    NO_TILE_OPTIONS: 'Нема доступних опција.',
    TILE_NAME: 'Име табле',
    ENTER_TILE_NAME: 'Унесите име табле',
    USE_FILTERS_FROM: 'Користи филтере из',
    USE_SORT_FROM: 'Користи сортирање из',
    USE_TIMELINE_FROM: 'Користи временску линију из',
    SHOW_TILE_SORT: 'Прикажи сортирање ове плоче',
    SHOW_TILE_FILTERS: 'Прикажи филтере плочице',
    SHOW_TILE_TIMELINE: 'Прикажи временску линију плочице',
    DASHBOARD: 'Контролна табла',
    TILE: 'Плоча',
    TILE_COPIED: 'Плоча је копирана!',
    CHART_COLUMN_OPTIONS: 'Опције колоне',
    CHART_ROW_OPTIONS: 'Опције реда',
    GENERAL_STYLING: 'Опште стилизовање',
    PER_ROW_STYLING: 'Стилизовање по реду',
    PER_COLUMN_STYLING: 'Стилизовање по колони',
    TEXT_STYLE: 'Стил текста',
    ROW_STYLE: 'Стил реда',
    COLOR: 'Боја',
    PALETTE: 'Палета',
    BACKGROUND: 'Позадина',
    BORDER: 'Обруб',
    SHADOW: 'Сенка',
    TOP_BORDER: 'Горњи обруб',
    BOTTOM_BORDER: 'Доњи обруб',
    INNER_BORDER: 'Унутрашњи обруб',
    RESET_GENERAL_STYLES: 'Ресетуј опште стилове',
    RESET_ALL_PER_ROW_STYLES: 'Ресетуј све стилове по реду',
    RESET_ALL_PER_COLUMN_STYLES: 'Ресетуј све стилове по колони',
    RESET_STYLES: 'Ресетуј стилове',
    ADD_TABLE: 'Нова табела димензија',
    ADD_VARIABLE: 'Нова променљива',
    ADD_SHEET: 'Нова табела',
    ADD_DASHBOARD: 'Нова контрольна панель',
    ADD_APP: 'Додај апликацију',
    ADD_FILE: 'Додај датотеку',
    ADD_FOLDER: 'Додај фасциклу',
    ENABLED: 'Омогућено',
    NEW_TEMPLATE: 'Нова шаблон',
    EDIT_TEMPLATE: 'Уреди шаблону',
    SAVE_SELECTION_AS_TEMPLATE: 'Сачувај избор као шаблон',
    TEMPLATE_CREATED: 'Шаблон је направљен',
    TEMPLATE_UPDATED: 'Шаблон је ажуриран',
    TEMPLATE_DELETED: 'Шаблон је обрисан',
    TEMPLATE_NAME: 'Име шаблона',
    TEMPLATE_DESCRIPTION: 'Опис шаблона',
    QUANTITY: 'Количина',
    ENTER_TEXT: 'Унесите текст',
    ENTER_NUMBER: 'Унесите број',
    PICK_A_DATE: 'Изаберите датум',
    ERROR_CREATING_DIMENSION: 'Грешка при креирању нове димензије',
    ALLOW_MULTI_CREATE: 'Дозволи креирање више ставки одједном',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Постави назив, опис и везе при креирању',
    ALLOW_PROPERTIES_ON_CREATE: 'Постави својства при креирању',
    NAMING_CONFIG_ENABLED: '(Конфигурација именовања омогућена)',
    DIMENSION_TABLE: 'Табела димензија',
    DIMENSION_TABLES: 'Табеле димензија',
    DIMENSION_MEMBER: 'Члан димензије',
    DIMENSION_MEMBERS: 'Чланови димензије',
    ASK_WHEN_CREATING: 'Питај при креирању',
    PREDEFINED_CONNECTIONS: 'Унапред дефинисане везе',
    REQUIRED: 'Потребно',
    CHOOSE_A_TABLE_FIRST: 'Прво изаберите табелу за постављање веза',
    BIND_TO_TIMELINE: 'Повежи са временском линијом',
    NEW_VARIABLE_COLUMN: 'Нова променљива колона',
    NEW_DIMENSION_COLUMN: 'Нова димензионална колона',
    NEW_LOOKUP_COLUMN: 'Нова колона претраге',
    NEW_COMPARISON_COLUMN: 'Нова колона за поређење',
    EDITING_CUSTOM_COLUMN: 'Уређивање прилагођене колоне',
    LOOKUP_PROPERTIES: 'Својства претраге',
    CALCULATION_COLUMN: 'Колона за израчунавање',
    ADD_COLUMNS: 'Додај колоне',
    COLUMN_NAME: 'Име колоне',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Да ли сте сигурни да желите обрисати ову колону?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Оставите празно за аутоматско генерисано име',
    NOTE_INSPECT_VALUE: 'Напомена: Инспект вредност функција приказује само до 500 редова. За преглед свих података, извезите комплетан скуп података.',
    COPY_FROM: 'Копирај од',
    COPY_FROM_TAGNAME: 'Копирај из {tag}',
    PREVIEW: 'Преглед',
    DECIMALS: 'Децимална места',
    SIGNS: 'Негативни бројеви',
    NEGATIVE_SIGNS: {
        SIGNED: 'Минус',
        UNSIGNED: 'Заграда',
        EXPLICIT: 'Плус/Минус',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Позитивно',
        NEGATIVE: 'Негативно',
    },
    BASE_UNIT: 'Основна јединица',
    BASE_UNITS: {
        ONES: 'Један',
        THOUSANDS: 'Хиљаде',
        THOUSANDS_K: 'Хиљаде (k)',
        MILLIONS: 'Милиони',
        MILLIONS_M: 'Милиони (m)',
        BILLIONS: 'Милијарде',
        BILLIONS_B: 'Милијарде (b)',
        AUTO: 'Аутоматски',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'ХРК',
    },
    MONTHS: {
        January: 'Јануар',
        February: 'Фебруар',
        March: 'Март',
        April: 'Април',
        May: 'Мај',
        June: 'Јун',
        July: 'Јул',
        August: 'Август',
        September: 'Септембар',
        October: 'Октобар',
        November: 'Новембар',
        December: 'Децембар',
    },
    MONTHS_SHORT: {
        Jan: 'Јан',
        Feb: 'Феб',
        Mar: 'Мар',
        Apr: 'Апр',
        May: 'Мај',
        Jun: 'Јун',
        Jul: 'Јул',
        Aug: 'Авг',
        Sep: 'Сеп',
        Oct: 'Окт',
        Nov: 'Нов',
        Dec: 'Дец',
    },
    DAYS: {
        Sunday: 'Недеља',
        Monday: 'Понедељак',
        Tuesday: 'Уторак',
        Wednesday: 'Среда',
        Thursday: 'Четвртак',
        Friday: 'Петак',
        Saturday: 'Субота',
    },
    DAYS_SHORT: {
        Sun: 'Нед',
        Mon: 'Пон',
        Tue: 'Уто',
        Wed: 'Сри',
        Thu: 'Чет',
        Fri: 'Пет',
        Sat: 'Суб',
    },
    CURRENCY: 'Валута',
    SIGNING_IN: 'Пријављивање...',
    NEW_RELATION_COLUMN: 'Нова колона релације',
    SELECT_TABLE_LOOKUP: 'Изаберите табелу за претрагу',
    SELECT_TABLE_RELATION: 'Повежи чланове реда са',
    SELECT_TABLE_PROPERTY: 'Изаберите својство из табеле',
    DISPLAY_TABLE_PROPERTY: 'Прикажи својство из табеле',
    FILTER_MEMBERS: 'Филтрирај избор чланова филтерима радног листа',
    TABLE_RELATION: 'Релација табеле',
    FILTER_DISPLAY: 'Филтрирај приказ',
    RELATE_TABLE: 'Повежи са табелом',
    USE_BLANKS: 'Користи празна поља',
    NO_DATA_TO_DISPLAY: 'Нема података за приказ',
    USE_REFERENCE_SORT: 'Користи његово сортирање',
    USE_REFERENCE_FILTERS: 'Користи његове филтере',
    USE_REFERENCE_TIMELINE: 'Користи његову временску линију',
    USE_REFERENCE_TEMPLATES: 'Користи његове шаблоне',
    USE_REFERENCE_ROWS: 'Користи његове редове',
    USE_REFERENCE_COLUMNS: 'Користи његове колоне',
    REFERENCE_ANOTHER_SHEET: 'Референцирај други радни лист',
    NO_SHEET_SELECTED: 'Ниједан радни лист није одабран',
    SELECT_SHEET: 'Изаберите радни лист',
    SHEET_REFERENCED: 'Радни лист успешно референциран',
    CANNOT_ADD_ROWS: 'Није могуће додати редове док је референцирано',
    CANNOT_EDIT_ROWS: 'Није могуће уређивати редове док је референцирано',
    CANNOT_EDIT_COLUMNS: 'Није могуће уређивати колоне док је референцирано',
    CANNOT_ADD_COLUMNS: 'Није могуће додати колоне док је референцирано',
    CANNOT_ADD_FILTERS: 'Није могуће додати филтере док је референцирано',
    REVERSE_DIMENSION: 'обрнуто повезана димензија',
    REMOVE_FROM_RULE: 'Уклони из правила',
    NEW_RULE: 'Ново правило',
    DUPLICATE_RULE: 'Дуплирај правило',
    REMOVE_RULE: 'Уклони правило',
    ENABLE_RULE: 'Омогући правило',
    DISABLE_RULE: 'Онемогући правило',
    RULE_DISABLED: 'Онемогућено',
    VARIABLE_LOCK_INFO_TITLE: 'Ова променљива ће користити само ово правило.',
    VARIABLE_LOCK_INFO_BODY: 'Остала правила ће бити замењена. Да бисте закључали целу променљиву, оставите одељак димензија празним.',
    DELETED: 'Обрисано',
    DONE: 'Готово',
    CHOOSE_ITEMS_TO_EXPORT: 'Изаберите ставке за извоз',
    UPLOAD_MODEL_FILE: 'Отпремите датотеку модела',
    NO_FILE_SELECTED: 'Није изабрана датотека',
    BACK: 'Назад',
    ALLOW_IMPORT_TO: 'Дозволи увоз у',
    FINISHED: 'Завршено',
    IMPORT_PREVIEW: 'Ово је преглед промена које би увоз применио са тренутним подешавањима.\n\nПромене:\n',
    IMPORT_FINISHED: 'Увоз завршен.\n\nПромене:\n',
    LOADING_MODEL: 'Увоз модела из датотеке...',
    CUSTOM_COLUMN: 'Прилагођена колона',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Прошири траку редова и колона',
    SEARCH_FOR_EXPRESSIONS: 'Претражи функције, променљиве, димензије…',
    NEW: 'Ново',
    SELECT_A_CELL: 'Изаберите ћелију која садржи вредност за приказ формуле',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Изаберите ћелију за уређивање редова',
    OR_COLUMNS: 'или колоне',
    MANAGE_PERMISSIONS_FOR: 'Управљање дозволама за "{name}"',
    VIEW_ONLY: 'Само преглед',
    DATA_EDIT: 'Уређивање података',
    EDIT_OWNED: 'Уреди своје',
    FULL_EDIT: 'Потпуно уређивање',
    UNKNOWN_USER: 'Непознат корисник',
    UNKNOWN_GROUP: 'Непозната група',
    BUTTON_STYLE: 'Стил дугмета',
    BUTTON_STYLES: {
        primary: 'Примарно',
        secondary: 'Секундарно',
        tertiary: 'Терцијарно',
        quaternary: 'Кватернарно',
    },
    APP_ICON: 'Икона апликације',
    LAST_MODIFIED_BY: 'Последњи пут изменио/ла {name}',
    LAST_MODIFIED_BY_COLUMN: 'Последњи изменио',
    LAST_MODIFIED_AT_COLUMN: 'Последња измена',
    SHOW: 'Прикажи',
    FORMULA_QA: 'Формула QA',
    TIME_LIMIT: 'Временско ограничење',
    RESTRICTIONS: 'Ограничења',
    SEARCH_FOR_USERS_GROUPS: 'Претражите кориснике или групе…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Претражите или делите са корисницима, групама или јавно…',
    STATUS_TRACKING: 'Праћење статуса',
    STATUS_TRACKING_MESSAGE: 'Праћење омогућава кориснику или групи да поднесу своје измене и затраже ваше одобрење.',
    TRACK_STATUS: 'Прати статус',
    STOP_TRACKING: 'Заустави праћење',
    RESTART_TRACKING: 'Поново покрени праћење',
    ALL: 'Све',
    TRACKED: 'Праћено',
    UNTRACKED: 'Непраћено',
    ALL_TRACKED: 'Сва праћена',
    MY_TRACKED: 'Моја праћена',
    MY_APPROVALS: 'Моја одобрења',
    ALL_SHARES: 'Сва дељења',
    SUPER_USERS: 'Суперкорисници',
    LOADING_SUPER_USERS: 'Учитавање суперкорисника...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Није могуће уређивати када је временско ограничење активно',
    CANNOT_EDIT_WHEN_TRACKED: 'Није могуће уређивати када се статус прати',
    EXPORT_SHARES: 'Извези дељене ставке',
    SHARE_COPIED: 'Дељење копирано!',
    SHARES_COPIED: 'Дељења копирана!',
    COPY_SHARE_IN_FOLDER: 'Копирај на све у овој фасцикли',
    COPY_AND_OVERRIDE_SHARES: 'Копирај и замени дељења',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Сва постојећа дељења на ставкама и фасциклама унутар ове биће замењена дељењима тренутне фасцикле.',
    COPY_ALL_SHARES_IN_FOLDER: 'Копирај и замени сва дељења у овој фасцикли',
    GRID_SINGLE_CHART_EXPLANATION: 'Један графикон са редовима највишег нивоа',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Мрежа малих графикона, по један за сваки ред највишег нивоа',
    DUPLICATE_KEYS_FOUND: 'Пронађени дуплирани кључеви',
    DUPLICATE_KEYS_PROMPT: 'Да ли желите да филтрирате и креирате само јединствене ставке?',
    NAMES_SHOULD_BE_UNIQUE: 'Имена морају бити јединствена',
    LIMIT_TO_FILTERED_OPTIONS: 'Ограничи на филтриране опције',

    // Toast messages
    SWITCHING_TENANT: 'Пребацивање радног простора',
    TENANT_SWITCHED_SUCCESS: 'Радни простор успешно пребачен',
    TENANT_SWITCH_FAILED: 'Није успело учитати податке новог радног простора. Молимо освежите страницу',
    FAILED_LOAD_MESSAGES: 'Није успело учитати поруке',
    NEW_CHAT_CREATED: 'Нови разговор створен!',
    FAILED_LOAD_CHATS: 'Није успело учитати разговоре.',
    FAILED_CREATE_CHAT: 'Није успело створити нови разговор.',
    FAILED_SEND_MESSAGE: 'Није успело створити нови разговор или послати поруку.',
    FAILED_RENAME_CHAT: 'Није успело преименовати разговор.',
    FAILED_DELETE_CHAT: 'Није успело обрисати разговор.',
    XLSX_FILE_ONLY: 'Само .xlsx датотеке',
    JSON_FILE_ONLY: 'Само .json датотеке',
    EXPORT_DONE: 'Готово!',
    LOCKS_SAVED: 'Закључавања сачувана',
    COPIED_TO_CLIPBOARD: 'Копирано у међуспремник',
    INVALID_INTERVAL: 'Неважећи интервал',
    SELECT_REQUIRED_DIMENSIONS: 'Одаберите потребне димензије.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Тип ентитета није наведен',

    // Button labels
    OK: 'У реду',
    DELETE_ENTITY: 'Обриши ентитет',
    SAVE_ENTITY: 'Сачувај ентитет',
    GENERATED_ENTITIES: 'Генерисани ентитети',
    NEW_ENTITY: 'Нови ентитет',
    ENTITIES: 'Ентитети',
    SHOW_LOGS: 'Прикажи записнике',
    CALCULATE: 'Израчунај',
    FORMULA_QA_TITLE: 'Формула QA',
    RENAME_CHAT: 'Преименуј разговор',
    SEND: 'Пошаљи',
    EXPORT_CURRENT_SHEET: 'Извези тренутну табелу',
    TERMINATE: 'Прекини',
    CONFIRM_UPDATE: 'Потврди ажурирање',

    // Form labels and placeholders
    FROM_DATE: 'Од датума',
    TO_DATE: 'До датума',
    AUDIT_TYPE: 'Тип ревизије',
    SELECT_AUDIT_TYPE: 'Одаберите тип ревизије',
    USER: 'Корисник',
    PAGE_SIZE: 'Величина странице',
    SELECT_PAGE_SIZE: 'Одаберите величину странице',
    SELECT_USER: 'Одаберите корисника',
    EXPORT_EXPANDED_ROWS: 'Извези тренутно проширене редове',
    EXPORT_ALL_ROWS: 'Извези све редове',
    EXPORT_FILENAME_LABEL: 'Назив',
    EXPORT_VARIABLE: 'Извези променљиву',
    EXPORT_FORMAT: 'Формат извоза',
    EXPORT_FORMAT_XLSX: '.xlsx (Excel 2007 и новији)',
    EXPORT_FORMAT_CSV_BOM: '.csv (компатибилно са Excel-ом)',
    EXPORT_FORMAT_CSV: '.csv (чисти подаци)',
    EXPORT_FORMAT_JSON: '.json',
    INCLUDE_CELLS: 'Укључи ћелије',
    INCLUDE_MEMBERS: 'Укључи чланове',
    MESSAGE_FARSEER_AI: 'Порука за FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Унесите ново име разговора',
    FLAG: 'Ознака',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Дај ми кратак сажетак модела',
    CHAT_SUGGESTION_DIMENSIONS: 'Постоје ли варијабле које имају више димензија од варијабли коришћених у њиховој формули?',
    CHAT_SUGGESTION_DELAY: 'Користе ли неке варијабле функцију delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Наведи све варијабле на захтев',
    CHAT_SUGGESTION_MEASURES: 'Наведи све мере',
    CHAT_SUGGESTION_FIXED: 'Наведи све варијабле које користе фиксну димензију',
    CHAT_SUGGESTION_DATE: 'Наведи све димензије које имају својство датума',

    // Loading defaults
    DEFAULT_LOADING: 'Учитавање...',
    DEFAULT_SUCCESS: 'Успех!',

    // Audit logs
    TOTAL_RESULTS: 'Укупно резултата: {count}',
    PAGE_OF_TOTAL: 'Страница {current} од {total}',
    DB_ID: 'ИД базе',
    DATE_AND_TIME: 'Датум и време',
    LOG_TYPE: 'Тип записника',
    DATA: 'Подаци',

    // Entity debugger
    NO_TYPES: 'Нема типова',

    // Formula QA Modal
    RESULT: 'Резултат: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Унесите формулу за израчун резултата.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Извоз одабраних ставки модела...',

    // Search
    RECENTLY_SEARCHED: 'Недавно претражено',
};

export default {
    ...(baseLanguageValues as Translation),
    ...translationValues,
};
